var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('warehouse-form',{attrs:{"loading":_vm.loading,"warehouseData":_vm.warehouse,"formErrors":_vm.formErrors},on:{"warehouseSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }